export default {
  chatList:[],
  currentReceiveMessage: [],
  isChatSent: false,
}
